import type { RouteRecordRaw } from 'vue-router';
import { setupLayouts } from 'virtual:generated-layouts';
import { routes } from 'vue-router/auto-routes';
import { INDEX_ROUTE, NOT_FOUND_ROUTE, RELOAD_ROUTE, SUB_APP_ROUTES } from '@/router/base';
import forEachDeep from '@/utils/function/forEachDeep';
import getBreadcrumbList from '@/utils/getBreadcrumbList';

/**
 * 遍历路由，添加面包屑相关参数
 * @param routesList
 */
function handleRoutes(routesList: RouteRecordRaw[]) {
  forEachDeep<RouteRecordRaw>(routesList, (route, parent) => {
    if (!route.meta) {
      route.meta = {};
    }
    // 如果当前路由path不是以'/'开头，需要拼接父路由path
    route.path =
      route.path.charAt(0) === '/' || route.meta?.isLink
        ? route.path
        : `${parent?.path || ''}${route.path ? '/' : ''}${route.path}`;

    // 添加父路由引用，方便遍历
    route.meta.__parent__ = parent;
    route.meta._breadcrumbList = getBreadcrumbList(route);
    return false;
  });

  return routesList;
}

/**
 * 从模块中获取路由
 */
function getRoutesFromModules() {
  const modules = import.meta.glob('./modules/*.ts', { eager: true });

  function formatModules(_modules: any, result: RouteRecordRaw[]) {
    Object.keys(_modules).forEach((key) => {
      const defaultModule = _modules[key].default;
      if (!defaultModule) return;
      const moduleList = Array.isArray(defaultModule) ? [...defaultModule] : [defaultModule];
      result.push(...moduleList);
    });
    return result;
  }

  const appRoutes: RouteRecordRaw[] = formatModules(modules, []);

  const routesList: RouteRecordRaw[] = [INDEX_ROUTE, ...appRoutes, RELOAD_ROUTE, NOT_FOUND_ROUTE, ...SUB_APP_ROUTES];

  return routesList;
}

/**
 * 静态路由
 */
const constantRoutes = handleRoutes(getRoutesFromModules());

routes.push(...SUB_APP_ROUTES);

/**
 * 文件系统路由
 */
const fileSystemRoutes = setupLayouts(routes);

export { constantRoutes, fileSystemRoutes };
